import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { referralRoute } from '.'

const InvitationCodes = lazyRouteComponent(
  () => import('../../../pages/profile/referral/invitation-codes'),
)

// `referral_id` is already validated by the parent `referralRoute`; redefining
// it here is rejected by TanStack Router ("Top level search params cannot be
// redefined by child routes!") and the resulting error-sentinel type poisons
// the route tree, causing TS2589 on `to`/navigate elsewhere. Inherit instead.
export const invitationCodesRoute = createRoute({
  getParentRoute: () => referralRoute,
  path: 'codes',
  component: InvitationCodes,
})
